import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Login from "@/views/Login";

// Authentication guards
import AuthGuard from "./auth-guard";
import AdminGuard from "./admin-guard";
import StaffGuard from "./staff-guard";
import AcademicGuard from "./academic-guard";
import OrgGuard from "./org-guard";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/admin",
      component: () => import(/* webpackChunkName: "admin" */ "@/views/admin"),
      children: [
        {
          path: "/admin/courses",
          name: "Courses",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/courses")
        },
        {
          path: "/admin/courses/:course",
          name: "Course",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/courses/course")
        },
        {
          path: "/admin/courses/:course/:unit",
          name: "Unit",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/courses/unit")
        },
        {
          path: "/admin/courses/:course/:unit/:step",
          name: "step",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/courses/unit/step")
        },
        {
          path: "/admin/administrators",
          name: "AdminList",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/administrators")
        },
        {
          path: "/admin/staff",
          name: "StaffList",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/staff")
        },
        {
          path: "/admin/academic",
          name: "AcademicList",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/academic")
        },
        {
          path: "/admin/organisations",
          name: "Organisations",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/organisations")
        },
        {
          path: "/admin/setup",
          name: "setup",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/setup")
        },
        {
          path: "",
          name: "AdminHome",
          component: () =>
            import(/* webpackChunkName: "admin" */ "@/views/admin/home")
        }
      ],
      beforeEnter: AdminGuard
    },
    {
      path: "/student",
      component: () =>
        import(/* webpackChunkName: "student" */ "@/views/student"),
      children: [
        {
          path: "",
          name: "studentPlacements",
          component: () =>
            import(/* webpackChunkName: "student" */ "@/views/student/placements")
        },
        {
          //  path: "/student/placements/:key",
          path: "/student/:key",
          name: "studentPlacement",
          component: () =>
            import(/* webpackChunkName: "student" */ "@/views/student/placements/placement")
        }
        //{
        //  path: "",
        //  name: "studentHome",
        //  component: () =>
        //    import(/* webpackChunkName: "student" */ "@/views/student/home")
        //}
      ],
      beforeEnter: AuthGuard
    },
    {
      path: "/staff",
      component: () => import(/* webpackChunkName: "staff" */ "@/views/staff"),
      children: [
        {
          path: "",
          name: "staffPlacements",
          component: () =>
            import(/* webpackChunkName: "staff" */ "@/views/staff/placements")
        },
        {
          path: "/staff/:uid/",
          name: "staffPlacement",
          component: () =>
            import(/* webpackChunkName: "staff" */ "@/views/staff/placements/placement")
        }
      ],
      beforeEnter: StaffGuard
    },
    {
      path: "/academic",
      component: () =>
        import(/* webpackChunkName: "academic" */ "@/views/academic"),
      children: [
        {
          path: "",
          name: "academicPlacements",
          component: () =>
            import(/* webpackChunkName: "academic" */ "@/views/academic/placements")
        },
        {
          path: "/academic/:uid/",
          name: "academicPlacement",
          component: () =>
            import(/* webpackChunkName: "academic" */ "@/views/academic/placements/placement")
        }
      ],
      beforeEnter: AcademicGuard
    },
    {
      path: "/organisation",
      component: () =>
        import(/* webpackChunkName: "organisation" */ "@/views/organisation"),
      children: [
        {
          path: "",
          name: "organisationPlacements",
          component: () =>
            import(/* webpackChunkName: "organisation" */ "@/views/organisation/placements")
        },
        {
          path: "/organisation/:uid/",
          name: "organisationPlacement",
          component: () =>
            import(/* webpackChunkName: "organisation" */ "@/views/organisation/placements/placement")
        }
      ],
      beforeEnter: OrgGuard
    },
    { path: "*", redirect: "/" }
  ]
});
